import React from 'react'
export const ResponsiveImage = ({ centered = false, src }: { centered: boolean; src: string }) => (
  <>
    <img src={src} style={{ maxHeight: '144px' }} className={`show-on-mobile ui image ${centered ? 'centered' : ''}`} />
    <img src={src} style={{ height: '190px' }} className={`hide-on-mobile ui image ${centered ? 'centered' : ''}`} />
  </>
)
